module.exports = __webpack_public_path__ + "static/img/fangzi.6587816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/fangzi.png
// module id = NOhc
// module chunks = 44